import { type InfiniteData, type QueryClient } from 'react-query'

import { type IInfinitePage, type IPost } from 'types/interfaces/ITypes'

type PostPatch = Partial<IPost> & Pick<IPost, 'id'>

const updatePostPurchaseCache = async (
    purchasedPost: PostPatch,
    dataQuery: any,
    queryClient: QueryClient
) => {
    const cachedData =
        queryClient.getQueryData<InfiniteData<IInfinitePage>>(dataQuery)

    if (!cachedData) return

    const newData: InfiniteData<IInfinitePage> = {
        ...cachedData,
        pages: cachedData.pages.map(singleFeedPage => ({
            ...singleFeedPage,
            page: {
                ...singleFeedPage.page,
                data: {
                    ...singleFeedPage.page.data,
                    data: singleFeedPage.page.data.data.map(post =>
                        post.id === purchasedPost.id
                            ? {
                                ...post,
                                ...purchasedPost,
                            }
                            : post
                    )
                }
            }
        }))
    }

    queryClient.setQueryData<InfiniteData<IInfinitePage>>(
        dataQuery,
        newData
    )
}

export { updatePostPurchaseCache }